<fgb-banner [bannerTitle]="'nav.contact.us' | translate"></fgb-banner>

<fgb-page-header [pageTitle]="'nav.contact.us'" [backButtonLink]="'/'" [showBalance]="false" [showQr]="false"></fgb-page-header>
<fgbcl-contact-us></fgbcl-contact-us>
